"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.UrlAdapter = void 0;
var Utility_1 = require("./Utility");
var UrlAdapter = /** @class */ (function () {
    function UrlAdapter() {
    }
    UrlAdapter.prototype.getConfiguration = function (options) {
        var params = new URLSearchParams(window.location ? window.location.search : undefined);
        /*
        We are using passed options here becase we can pass parameters to ConfigurationService constructor.
        This is case for testing without platform parent.
        */
        var environment = (0, Utility_1.defaultToAny)(params.get('environment'), params.get('env'), options.environment, undefined);
        var platformDataCenter = (0, Utility_1.defaultToAny)(params.get('platformDataCenter'), params.get('platformDc'), options.platformDataCenter, undefined);
        var platformName = (0, Utility_1.defaultToAny)(params.get('platformName'), params.get('platform'), options.platformName, undefined);
        var productName = (0, Utility_1.defaultToAny)(params.get('productName'), params.get('product'), params.get('game'), options.productName, undefined);
        var productId = (0, Utility_1.defaultToAny)(params.get('productId'), params.get('cpvUuid'), options.productId, undefined);
        var tenantId = (0, Utility_1.defaultToAny)(params.get('tenantId'), params.get('tenant'), params.get('company'), options.tenantId, undefined);
        var locale = (0, Utility_1.defaultToAny)(params.get('locale'), params.get('language'), params.get('lang'), options.locale, undefined);
        var applicationName = (0, Utility_1.defaultToAny)(params.get('applicationName'), params.get('appName'), params.get('app'), options.applicationName, undefined);
        var messageProtocol = (0, Utility_1.defaultToAny)(params.get('messageProtocol'), params.get('integrationType'), params.get('messaging'), options.messageProtocol, undefined);
        var channelId = (0, Utility_1.defaultToAny)(params.get('channelId'), params.get('channel'), options.channelId, undefined);
        var betshopId = (0, Utility_1.defaultToAny)(params.get('betshopId'), params.get('betshop'), options.betshopId, undefined);
        var deviceId = (0, Utility_1.defaultToAny)(params.get('deviceId'), params.get('device'), options.deviceId, undefined);
        var isIntegration = (0, Utility_1.defaultToAny)(params.get('isIntegration'), params.get('integration'), options.isIntegration, undefined);
        var ui = (0, Utility_1.defaultToAny)(params.get('ui'), options.ui, undefined);
        var layout = (0, Utility_1.defaultToAny)(params.get('layout'), options.layout, undefined);
        var result = {
            environment: environment,
            platformName: platformName,
            platformDataCenter: platformDataCenter,
            productId: productId,
            productName: productName,
            tenantId: tenantId,
            locale: locale,
            applicationName: applicationName,
            messageProtocol: messageProtocol,
            channelId: channelId,
            betshopId: betshopId,
            deviceId: deviceId,
            isIntegration: isIntegration,
            ui: ui,
            layout: layout,
        };
        /*
        Check third party parameters and
        store them in separate object.
        */
        result.platformConfig = {
            clientPlatform: (0, Utility_1.defaultToAny)(params.get('clientPlatform'), params.get('clientplatform'), undefined),
            clientType: (0, Utility_1.defaultToAny)(params.get('clientType'), params.get('clienttype'), undefined),
            gameCode: (0, Utility_1.defaultToAny)(params.get('gameCode'), params.get('game'), undefined),
            tenantId: (0, Utility_1.defaultToAny)(params.get('tenantId'), params.get('tenantid'), params.get('skinId'), params.get('skinid'), undefined),
            playerId: (0, Utility_1.defaultToAny)(params.get('username'), params.get('playerId'), undefined),
            password: (0, Utility_1.defaultToAny)(params.get('password'), undefined),
            tempToken: (0, Utility_1.defaultToAny)(params.get('tempToken'), params.get('temptoken'), undefined),
            casino: (0, Utility_1.defaultToAny)(params.get('casino'), undefined),
        };
        return result;
    };
    return UrlAdapter;
}());
exports.UrlAdapter = UrlAdapter;
//# sourceMappingURL=UrlAdapter.js.map